import VDaterange from '@/components/utils/daterange/VDaterange'
import { ISO_FORMAT } from '@/components/utils/daterange/constants'
import { format, subDays } from 'date-fns'

import defaults from '@/modules/default'
const lang = defaults.language

export default {
  components: { VDaterange },
  data () {
    return {
      presets: [
        {
          label: lang.historic.filters.date_range.presets.all,
          range: ['0000-00-00', '0000-00-00']
        },
        {
          label: lang.historic.filters.date_range.presets.this_month,
          range: [
            format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), ISO_FORMAT),
            format(new Date(), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.this_year,
          range: [
            format(new Date(new Date().getFullYear(), 0, 1), ISO_FORMAT),
            format(new Date(), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.last_year,
          range: [
            format(new Date(new Date().getFullYear() - 1, 0, 1), ISO_FORMAT),
            format(new Date(new Date().getFullYear() - 1, 12, 0), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.today,
          range: [
            format(new Date(), ISO_FORMAT),
            format(new Date(), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.yesterday,
          range: [
            format(subDays(new Date(), 1), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.week,
          range: [
            format(subDays(new Date(), 1), ISO_FORMAT),
            format(subDays(new Date(), 7), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.month,
          range: [
            format(subDays(new Date(), 30), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.bimonthly,
          range: [
            format(subDays(new Date(), 60), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.quarterly,
          range: [
            format(subDays(new Date(), 90), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.year,
          range: [
            format(subDays(new Date(), 365), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        }
      ],
      presets_notnull: [
        {
          label: lang.historic.filters.date_range.presets.this_month,
          range: [
            format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), ISO_FORMAT),
            format(new Date(), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.this_year,
          range: [
            format(new Date(new Date().getFullYear(), 0, 1), ISO_FORMAT),
            format(new Date(), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.last_year,
          range: [
            format(new Date(new Date().getFullYear() - 1, 0, 1), ISO_FORMAT),
            format(new Date(new Date().getFullYear() - 1, 12, 0), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.today,
          range: [
            format(new Date(), ISO_FORMAT),
            format(new Date(), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.yesterday,
          range: [
            format(subDays(new Date(), 1), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.week,
          range: [
            format(subDays(new Date(), 1), ISO_FORMAT),
            format(subDays(new Date(), 7), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.month,
          range: [
            format(subDays(new Date(), 30), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.bimonthly,
          range: [
            format(subDays(new Date(), 60), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.quarterly,
          range: [
            format(subDays(new Date(), 90), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        },
        {
          label: lang.historic.filters.date_range.presets.year,
          range: [
            format(subDays(new Date(), 365), ISO_FORMAT),
            format(subDays(new Date(), 1), ISO_FORMAT)
          ]
        }
      ]
    }
  }
}
